import React from 'react'
import useProduct from 'store/SingleProductProvider'
import {
  DetailsContent,
  DetailsInfo,
  DetailsImg,
  DetailsInfoText,
} from './Details.style'

const Details = props => {
  const {
    product: { image },
  } = useProduct()
  const { details } = props
  const descriptionNotExists = !Boolean(details.description?.length > 10)

  return (
    <DetailsContent>
      <h2 id="product-details">ძირითადი ინფორმაცია</h2>
      <DetailsInfo fullWidth={descriptionNotExists}>
        <DetailsImg fullWidth={descriptionNotExists}>
          <img src={image || ''} alt="product details" />
        </DetailsImg>

        {details.description && (
          <DetailsInfoText>
            <h3>{details.title || ''}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: details.description || '',
              }}
            />
          </DetailsInfoText>
        )}
      </DetailsInfo>
    </DetailsContent>
  )
}

export default Details
